import { render, staticRenderFns } from "./OneInTwo.vue?vue&type=template&id=ac8039aa&scoped=true&"
import script from "./OneInTwo.vue?vue&type=script&lang=js&"
export * from "./OneInTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8039aa",
  null
  
)

export default component.exports